/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CreateSession: BridgeCommands.Command<
    Types.Common.Gameshare.CreateSessionParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GameShare',
    method: 'CreateSession',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DeleteSession: BridgeCommands.Command<
    Types.Common.Gameshare.DeleteSessionParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GameShare',
    method: 'DeleteSession',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ModifySession: BridgeCommands.Command<
    Types.Common.Gameshare.ModifySessionParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GameShare',
    method: 'ModifySession',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ConfigureControllerMapping: BridgeCommands.Command<
    Types.Common.Gameshare.ConfigureControllerMappingParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GameShare',
    method: 'ConfigureControllerMapping',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFullScreenProcessId: BridgeCommands.Command<
    Types.Common.Gameshare.GetFullScreenProcessIdParameters,
    Types.Common.Gameshare.GetFullScreenProcessIdReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GameShare',
    method: 'GetFullScreenProcessId',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CreateSessionNotification: BridgeCommands.Command<
    {},
    Types.Common.Gameshare.CreateSessionNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GameShare',
    method: 'CreateSessionNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SessionStatusUpdateNotification: BridgeCommands.Command<
    {},
    Types.Common.Gameshare.SessionStatusUpdateNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GameShare',
    method: 'SessionStatusUpdateNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AudioDeviceChangeNotification: BridgeCommands.Command<
    {},
    Types.Common.Gameshare.AudioDeviceChangeNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'GameShare',
    method: 'AudioDeviceChangeNotification',
    persistent: true
};

export const Gameshare = {
CreateSession,
DeleteSession,
ModifySession,
ConfigureControllerMapping,
GetFullScreenProcessId,
CreateSessionNotification,
SessionStatusUpdateNotification,
AudioDeviceChangeNotification
};
